import React from "react";

const PipedriveIntegrationIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 40,
  height: 40,
  viewBox: "0 0 40 40",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2785_1035)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 20,
  cy: 20,
  r: 20,
  fill: "#08A742"
}), /*#__PURE__*/React.createElement("mask", {
  id: "mask0_2785_1035",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 11,
  y: 10,
  width: 18,
  height: 22
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.3983 18.0451C17.3983 20.0626 18.4218 22.239 20.6741 22.239C22.3443 22.239 24.0331 20.935 24.0331 18.0155C24.0331 15.4558 22.7056 13.7375 20.7296 13.7375C19.1196 13.7375 17.3983 14.8685 17.3983 18.0451ZM21.5231 10C25.5614 10 28.2768 13.1984 28.2768 17.9594C28.2768 22.6456 25.4163 25.9173 21.327 25.9173C19.3773 25.9173 18.1285 25.0822 17.4755 24.4778C17.4801 24.6211 17.4832 24.7816 17.4832 24.9529V31.3077H13.2998V14.3762C13.2998 14.13 13.2211 14.0522 12.9772 14.0522H11.5385V10.3443H15.0488C16.6651 10.3443 17.0788 11.1669 17.1575 11.801C17.8136 11.0656 19.1736 10 21.5231 10Z",
  fill: "white"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#mask0_2785_1035)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.3983 18.0451C17.3983 20.0626 18.4218 22.239 20.6741 22.239C22.3443 22.239 24.0331 20.935 24.0331 18.0155C24.0331 15.4558 22.7056 13.7375 20.7296 13.7375C19.1196 13.7375 17.3983 14.8685 17.3983 18.0451ZM21.5231 10C25.5614 10 28.2768 13.1984 28.2768 17.9594C28.2768 22.6456 25.4163 25.9173 21.327 25.9173C19.3773 25.9173 18.1285 25.0822 17.4755 24.4778C17.4801 24.6211 17.4832 24.7816 17.4832 24.9529V31.3077H13.2998V14.3762C13.2998 14.13 13.2211 14.0522 12.9772 14.0522H11.5385V10.3443H15.0488C16.6651 10.3443 17.0788 11.1669 17.1575 11.801C17.8136 11.0656 19.1736 10 21.5231 10Z",
  fill: "white"
}))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2785_1035"
}, /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  fill: "white"
}))));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(PipedriveIntegrationIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;